// src/components/dashboard/EditAttendeeModal.js
// Updated: 10/20/2025 09:00 AM (Accept and use zIndexClass prop)

import React, { useState, useEffect } from 'react';
import Spinner from '../common/Spinner';
import ModalWrapper from '../common/ModalWrapper';

// Accept zIndexClass prop
const EditAttendeeModal = ({ attendee, merchandise, onSave, onCancel, zIndexClass }) => {
  const [name, setName] = useState('');
  const [age, setAge] = useState('');
  const [tshirtSize, setTshirtSize] = useState('');
  const [loading, setLoading] = useState(false);
  const tShirtOptions = merchandise?.find(item => item.itemName.toLowerCase().includes('t-shirt'));

  useEffect(() => {
    if (attendee) {
      setName(attendee.name || '');
      setAge(attendee.age || '');
      setTshirtSize(attendee.tshirtSize || '');
    }
  }, [attendee]);

  const handleSave = (e) => {
    e.preventDefault();
    setLoading(true);
    // Include attendanceCost if available to preserve it
    onSave({ ...attendee, name, age, tshirtSize, attendanceCost: attendee.attendanceCost });
    // setLoading(false); // Let parent handle loading state after save logic
  };

  return (
    // Pass zIndexClass down to ModalWrapper
    <ModalWrapper onClose={onCancel} size="sm" zIndexClass={zIndexClass}>
      <div className="p-6 border-b"><h3 className="text-xl font-semibold text-neutral-gray">Edit Attendee</h3></div>
      <form onSubmit={handleSave}>
         {/* Form content remains the same */}
         <div className="p-6 space-y-4">
          <div><label htmlFor="edit-name" className="block text-sm font-medium text-gray-700">Full Name</label><input type="text" id="edit-name" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"/></div>
          <div><label htmlFor="edit-age" className="block text-sm font-medium text-gray-700">Age</label><input type="number" id="edit-age" value={age} onChange={(e) => setAge(e.target.value)} required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"/></div>
          {tShirtOptions && (
            <div>
              <label htmlFor="edit-tshirt" className="block text-sm font-medium text-gray-700">T-Shirt Size</label>
              <select id="edit-tshirt" value={tshirtSize} onChange={(e) => setTshirtSize(e.target.value)} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md">
                <option value="">No T-Shirt</option>
                {tShirtOptions.sizes.map((sizeInfo) => (<option key={sizeInfo.size} value={sizeInfo.size}>{sizeInfo.size} {sizeInfo.upcharge > 0 && `(+$${sizeInfo.upcharge.toFixed(2)})`}</option>))}
              </select>
            </div>
          )}
        </div>
        <div className="p-6 bg-gray-50 rounded-b-lg flex justify-end items-center gap-4">
          <button type="button" onClick={onCancel} className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50">Cancel</button>
          <button type="submit" disabled={loading} className="px-4 py-2 bg-primary text-white rounded-md hover:bg-blue-700 text-sm font-medium disabled:opacity-50 flex items-center">{loading ? <Spinner size="sm" /> : 'Save Changes'}</button>
        </div>
      </form>
    </ModalWrapper>
  );
};

export default EditAttendeeModal;